export const createCrew = {
    state: {
        crewOptions: {}
    },

    getters: {
        crewOptions(state) {
            return state.crewOptions;
        }
    },

    mutations: {
        updateCrewOptions(state, data) {
            state.crewOptions = {
                weight: data.shift().data,
                age: data.shift().data,
                gender: data.shift().data
            };
        }
    },

    actions: {
        getCrewAgeOptions(context) {
            return context.dispatch('get', {
                url: api + 'age-options'
            });
        },

        getCrewGenderOptions(context) {
            return context.dispatch('get', {
                url: api + 'gender-options'
            });
        },

        getCrewGroupOptions(context) {
            return context.dispatch('get', {
                url: api + 'crew-group-options'
            });
        },

        getCrewWeightOptions(context) {
            return context.dispatch('get', {
                url: api + 'weight-options'
            });
        },

        getCrewStructures(context, payload) {
            return context.dispatch('get', {
                url: api + 'crew-structures',
                params: {
                    sport_id: (payload && payload.sportId) || null
                }
            });
        },

        getTelemetryStandardMeasurementOptions(context) {
            return context.dispatch('get', {
                url: api + 'telemetry-standards-options'
            });
        },

        createCrew(context, payload) {
            return context.dispatch('post', {
                url: api + 'create-crew',
                data: payload
            });
        },

        editCrew(context, payload) {
            return context.dispatch('post', {
                url: api + 'edit-crew',
                data: payload
            });
        },

        editCrews(context, payload) {
            return context.dispatch('post', {
                url: api + 'edit-crews',
                data: payload
            });
        },

        assignCrewToSessions(context, payload) {
            return context.dispatch('post', {
                url: api + 'assign-crews-to-sessions',
                data: payload
            });
        },

        getSessionCrews(context, payload) {
            let include = _.has(payload, 'include') ? ',' + payload.include : '';
            let filters = _.has(payload, 'filters') ? '?' + payload.filters : '';

            return context.dispatch('get', {
                url: api + 'session/' + payload.id + filters,
                params: {
                    club_id: payload.club_id,
                    include: include
                }
            });
        },

        publishCrews(context, payload) {
            return context.dispatch('post', {
                url: api + 'update-session',
                data: { ...payload }
            });
        },

        getCrewOptions(context) {
            if (Object.keys(context.state.crewOptions).length) {
                // do not refresh if it's already in store
                return;
            }
            return Promise.all([
                context.dispatch('getCrewAgeOptions'),
                context.dispatch('getCrewGenderOptions'),
                context.dispatch('getCrewWeightOptions')
            ]).then(responses => {
                context.commit('updateCrewOptions', responses);
            });
        },

        getClubGmts(context, payload) {
            return context.dispatch('get', {
                url: api + 'get-gmts',
                params: {
                    club_id: context.rootGetters.selectedClubId,
                    sport: (payload && payload.sportId) || null
                }
            });
        }
    }
};

export default createCrew;
